import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import ToolbarMui from "@mui/material/Toolbar";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import Grid from "@mui/material/Grid";
import {TimeUtil} from "../utils/TimeUtil";
import {Snackbar} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import {BASE_URL_API} from "../Const";
import {BackButton,BottomMenu} from './HookUtils'
import {useProductUnits} from "../Repository/useProductUnits";


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class OrderComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            orderList: [],
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            units: props.units_prop,
            marketName: ""

        };

    }

    componentDidMount() {
        this.fetchOrderList()
    }

    fetchOrderList = () => {
        fetch(BASE_URL_API + 'order', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code === 200) {
                        this.setState({orderList: results.data,  marketName: results.markets?.name || "" })

                    }

                },
                (error) => {
                    console.log("error")
                }
            );
    }

    render() {

        const onConfirmOrder = (orderId) => {
            console.log(orderId)
            fetch(BASE_URL_API + 'order/confirm', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    order_id: orderId
                })
            })
                .then(response => response.json())
                .then(result => {
                    if (result.code === 200) {
                        this.setState({openSnackbar: true, message: result.message, snackbarType: "success"})

                        this.fetchOrderList()
                    } else {
                        this.setState({openSnackbar: true, message: result.message, snackbarType: "error"})
                    }


                })
        };

        const headerCellStyle = {
            borderBottom: '1px solid #ccc',
            padding: '3px 6px',
            fontSize: 'clamp(12px, 1vw, 14px)',   // responsive font
            color: 'black',
            textAlign: 'center',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };

        const bodyCellStyle = {
            borderBottom: '1px solid #eee',
            padding: '6px 12px',
            fontSize: 'clamp(12px, 2.5vw, 14px)',   // responsive font
            color: 'gray',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };

        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }

        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ShoppingBasketOutlinedIcon style={{color: 'black'}}/>

                        <ListItemText align="center"><strong style={{
                            fontSize: 'clamp(16px, 3vw, 18px)',   // responsive
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }} >{"سفارشات"}</strong></ListItemText>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>
                <List style={{ marginTop: 70, padding: '0 8px' /* small side padding for mobile */ }}>
                    {this.state.orderList.map((item) => (
                        <ListItem
                            key={item.id}
                            style={{ justifyContent: 'center', alignItems: 'center' }}
                        >
                            <div style={{ maxWidth: '100%', width: '100%',  /* cap on large screens */ }}>
                                <Paper style={{padding: '8px'}}>
                                    <ListItemText style={{ textAlign: 'right' }}>
                                        <Grid container spacing={1} style={{ borderTop: '1px solid #ddd', padding: '8px 0' }}>
                                            {/* هدر جدول - فقط دسکتاپ */}
                                            <Grid item xs={0} sm={2} sx={{ display: { xs: 'none', sm: 'block' } }} style={headerCellStyle}>
                                                <strong>فروشگاه</strong>
                                            </Grid>
                                            <Grid item xs={0} sm={3} sx={{ display: { xs: 'none', sm: 'block' } }} style={headerCellStyle}>
                                                <strong>عنوان</strong>
                                            </Grid>
                                            <Grid item xs={0} sm={2} sx={{ display: { xs: 'none', sm: 'block' } }} style={headerCellStyle}>
                                                <strong>قیمت</strong>
                                            </Grid>
                                            <Grid item xs={0} sm={2} sx={{ display: { xs: 'none', sm: 'block' } }} style={headerCellStyle}>
                                                <strong>تعداد / واحد</strong>
                                            </Grid>
                                            <Grid item xs={0} sm={3} sx={{ display: { xs: 'none', sm: 'block' } }} style={headerCellStyle}>
                                                <strong>مجموع</strong>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <div style={{ background: '#e7e7e7', height: 1, marginBottom: 8 }} />
                                            </Grid>

                                            {item.meta_orders.map(metaItem =>
                                                metaItem.product ? (
                                                    <React.Fragment key={metaItem.id}>
                                                        {/* ===== دسکتاپ: جدول پنج ستونه ===== */}
                                                        <Grid item xs={0} sm={2} sx={{ display: { xs: 'none', sm: 'block' } }} style={bodyCellStyle}>
                                                            {item.market?.name ?? '---'}
                                                        </Grid>
                                                        <Grid item xs={0} sm={3} sx={{ display: { xs: 'none', sm: 'block' } }} style={bodyCellStyle}>
                                                            {metaItem.product.title}
                                                        </Grid>
                                                        <Grid item xs={0} sm={2} sx={{ display: { xs: 'none', sm: 'block' } }} style={bodyCellStyle}>
                                                            {parseInt(metaItem.product.price) - parseInt(metaItem.product.del_price)}
                                                        </Grid>
                                                        <Grid item xs={0} sm={2} sx={{ display: { xs: 'none', sm: 'block' } }} style={bodyCellStyle}>
                                                            {metaItem.product.unit_id
                                                                ? (() => {
                                                                    const unit = this.state.units.find(
                                                                        u => u.id + '' === metaItem.product.unit_id + ''
                                                                    );
                                                                    return unit
                                                                        ? `${unit.unit_type} ${metaItem.count} ${unit.name}`
                                                                        : 'نامشخص';
                                                                })()
                                                                : 'نامشخص'}
                                                        </Grid>
                                                        <Grid item xs={0} sm={3} sx={{ display: { xs: 'none', sm: 'block' } }} style={bodyCellStyle}>
                                                            {(parseInt(metaItem.product.price) -
                                                                parseInt(metaItem.product.del_price)) * metaItem.count}
                                                        </Grid>

                                                        {/* ===== موبایل: هر عنوان بالای مقدار ===== */}
                                                        <Grid item xs={12} sm={0} sx={{ display: { xs: 'block', sm: 'none' } }}>
                                                            <p><strong>فروشگاه:</strong> {item.market?.name ?? '---'}</p>
                                                            <p><strong>عنوان:</strong> {metaItem.product.title}</p>
                                                            <p>
                                                                <strong>قیمت:</strong>{' '}
                                                                {parseInt(metaItem.product.price) - parseInt(metaItem.product.del_price)}
                                                            </p>
                                                            <p>
                                                                <strong>تعداد / واحد:</strong>{' '}
                                                                {metaItem.product.unit_id
                                                                    ? (() => {
                                                                        const unit = this.state.units.find(
                                                                            u => u.id + '' === metaItem.product.unit_id + ''
                                                                        );
                                                                        return unit
                                                                            ? `${unit.unit_type} ${metaItem.count} ${unit.name}`
                                                                            : 'نامشخص';
                                                                    })()
                                                                    : 'نامشخص'}
                                                            </p>
                                                            <p>
                                                                <strong>مجموع:</strong>{' '}
                                                                {(parseInt(metaItem.product.price) -
                                                                    parseInt(metaItem.product.del_price)) * metaItem.count}
                                                            </p>
                                                            <div style={{ background: '#eee', height: 1, margin: '8px 0' }} />
                                                        </Grid>
                                                    </React.Fragment>
                                                ) : null
                                            )}








                                        {/* بقیه کد شما برای اطلاعات سفارش */}

                                            <Grid item xs={12} style={{ background: '#fafafa', marginTop: 12 }}>
                                                <p style={{ paddingRight: 12, fontSize: 'clamp(12px,2.5vw,14px)' }} align="right">
                                                    <strong>آدرس: </strong>
                                                    {item.address}
                                                </p>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <p
                                                    style={{
                                                        paddingRight: 12,
                                                        color: '#46c139',
                                                        whiteSpace: 'nowrap',
                                                        fontSize: 'clamp(12px,2.5vw,14px)'
                                                    }}
                                                    align="right"
                                                >
                                                    {'مجموع: ' +
                                                        item.total
                                                            .toString()
                                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                                                        ' تومان'}
                                                </p>
                                            </Grid>

                                            {item.status === 'delivery' && (
                                                <Grid style={{ margin: 12 }} item xs={12}>
                                                    <Button
                                                        onClick={() => onConfirmOrder(item.id)}
                                                        variant="contained"
                                                        style={{
                                                            width: '100%',
                                                            color: 'white',
                                                            background: 'green',
                                                            fontSize: 'clamp(14px,2.5vw,16px)'
                                                        }}
                                                        align="right"
                                                    >
                                                        تایید تحویل سفارش
                                                    </Button>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </ListItemText>
                                </Paper>
                            </div>
                        </ListItem>
                    ))}
                </List>

                <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType} sx={{width: '100%'}}>
                        {this.state.message}
                    </Alert>
                </Snackbar>
                <BottomMenu/>
            </React.Fragment>
        );
    }

}
